const executeScripts = (...callbacks) => {
  if (callbacks.length !== 0) {
    callbacks.forEach(cb => cb && cb());
  }
};

export default executeScripts;
